import React from 'react';
import { AlertTriangle, Home, RefreshCw } from 'lucide-react';
import { apiConfig } from '../lib/api';
import { translateText } from '../i18n/runtime';

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('App render failed:', error, info);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    const message = error?.message || translateText('Unexpected frontend error');
    return (
      <div className="min-h-screen bg-white flex items-center justify-center px-6">
        <div className="w-full max-w-xl border border-[#E3E2E0] rounded-xl p-6 shadow-sm">
          <div className="w-10 h-10 rounded-lg bg-[#FFEBE9] text-[#CE3636] flex items-center justify-center mb-4">
            <AlertTriangle className="w-5 h-5" />
          </div>
          <h1 className="text-xl font-semibold text-[#191919]">{translateText('App could not load this screen')}</h1>
          <p className="mt-2 text-sm text-[#6B6B6B]">
            {message}
          </p>
          <div className="mt-4 rounded-lg bg-[#FBFBFA] border border-[#E3E2E0] p-3 text-xs text-[#6B6B6B] space-y-1">
            <div><span className="font-medium text-[#191919]">Backend:</span> {apiConfig.backendUrl || translateText('same origin / not configured')}</div>
            <div><span className="font-medium text-[#191919]">Raw env:</span> {apiConfig.rawBackendUrl || translateText('empty')}</div>
          </div>
          <div className="mt-5 flex flex-wrap gap-2">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="inline-flex items-center gap-2 px-3.5 py-2 bg-[#0A0A0A] text-white text-sm font-medium rounded-lg"
            >
              <RefreshCw className="w-4 h-4" />
              {translateText('Reload')}
            </button>
            <a
              href="/app"
              className="inline-flex items-center gap-2 px-3.5 py-2 border border-[#E3E2E0] text-[#191919] text-sm font-medium rounded-lg hover:bg-[#FBFBFA]"
            >
              <Home className="w-4 h-4" />
              {translateText('Open app')}
            </a>
          </div>
        </div>
      </div>
    );
  }
}
